import {getCookie} from '../util.js'
import * as Sentry from '@sentry/browser'

// Accessible as $ecommercetracking or window.$ecommercetracking
class EcommerceTracking {
    pageView(pageTitle, pageLocation) {
        /**
     * Sends a view item event to Google Analytics.
     * @param {string} pageTitle - The page title.
     * @param {string} pageLocation - The URL.
    */
        try {
            if (typeof gtag !== 'undefined' && getCookie('acceptTrackingCookies')) {
                let gtag = function() {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push(arguments)
                }
                gtag('event', 'page_view', {
                    page_title: pageTitle,
                    page_location: pageLocation
                });
            }
        } catch(error) {
            Sentry.captureException(error);
        }
    }

    viewItem(item) {
    /**
     * Sends a view item event to Google Analytics and Meta Pixel.
     * @param {Object} item - Parameters for the view_item event.
     * @param {string} item.id - The ID of the item being viewed. Prefix p for products, prefix w for Workout, prefix r for Resource, prefix c for Course and prefix g for TeamSport/GameClass
     * @param {string} item.name - The name of the item being viewed.
     * @param {string} item.currency - The currency of the item being viewed (optional) default = SEK
     * @param {number} item.price - The price of the item being viewed incl. vat (optional) default = 0
     * @param {number} item.vat - The vat of the item being viewed (optional) default = 0
     * @param {number} item.count - The quantity of the item being viewed (optional) default = 1.
    */
    
        try {
            if (getCookie('acceptTrackingCookies')) {
                if (
                    typeof item === 'object' &&
                    Object.prototype.hasOwnProperty.call(item, 'id') && item.id &&
                    Object.prototype.hasOwnProperty.call(item, 'name') && item.name
                ) {
                    let newItem = {};
                    let value = 0;
          
                    newItem.currency = 'SEK'; //Default
                    if (Object.prototype.hasOwnProperty.call(item, 'currency') && item.currency) {
                        newItem.currency = item.currency;
                    }
                    newItem.price = 0; //Default
                    if (Object.prototype.hasOwnProperty.call(item, 'price') && item.price && !isNaN(item.price)) {
                        newItem.price = item.price;
                    }
                    let vat = 0; //Default
                    if (Object.prototype.hasOwnProperty.call(item, 'vat') && item.vat && !isNaN(item.vat)) {
                        vat = item.vat;
                    }
                    newItem.quantity = 1; //Default
                    if (Object.prototype.hasOwnProperty.call(item, 'count') && item.count && !isNaN(item.count)) {
                        newItem.quantity = item.count;
                    }

                    newItem.item_id = item.id;
                    newItem.item_name = item.name;
                    vat = 1 + (parseInt(vat) / 100);
                    newItem.price = Math.round(item.price / vat);
                    value = newItem.price * newItem.quantity;

                    if (typeof gtag !== 'undefined') {
                        let gtag = function() {
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push(arguments)
                        }
            
                        gtag('event', 'view_item', {
                            currency: newItem.currency,
                            value: value,
                            items: [newItem],
                        });
                    }

                    if (typeof fbq !== 'undefined') {
                        // eslint-disable-next-line
                        fbq('track', 'ViewContent', {
                            content_ids: [newItem.item_id],
                            content_name: newItem.item_name,
                            content_type: 'product',
                            value: value,
                            currency: newItem.currency
                        });
                    }
                }
            }
        } catch(error) {
            Sentry.captureException(error);
        }
    }

    addToCart(item) { 
    /**
     * Sends an add to cart event to Google Analytics and Meta Pixel.
     * @param {Object} item - Parameters for the add to cart event.
     * @param {string} item.id - The ID of the item being added to cart. Prefix p for products, prefix w for Workout, prefix r for Resource, prefix c for Course and prefix g for TeamSport/GameClass
     * @param {string} item.name - The name of the item being added to cart.
     * @param {string} item.currency - The currency of the item being added to cart (optional) default = SEK
     * @param {number} item.price - The price of the item being added to cart incl. vat (optional) default = 0
     * @param {number} item.vat - The vat of the item being added to cart (optional) default = 0
     * @param {number} item.count - The quantity of the item being added to cart (optional) default = 1.
    */
    
        try {
            if (typeof gtag !== 'undefined' && getCookie('acceptTrackingCookies')) {
                if (
                    typeof item === 'object' &&
                    Object.prototype.hasOwnProperty.call(item, 'id') && item.id &&
                    Object.prototype.hasOwnProperty.call(item, 'name') && item.name
                ) {
                    let newItem = {};
                    let value = 0;

                    newItem.currency = 'SEK'; //Default
                    if (Object.prototype.hasOwnProperty.call(item, 'currency') && item.currency) {
                        newItem.currency = item.currency;
                    }
                    newItem.price = 0; //Default
                    if (Object.prototype.hasOwnProperty.call(item, 'price') && item.price && !isNaN(item.price)) {
                        newItem.price = item.price;
                    }
                    let vat = 0; //Default
                    if (Object.prototype.hasOwnProperty.call(item, 'vat') && item.vat && !isNaN(item.vat)) {
                        vat = item.vat;
                    }
                    newItem.quantity = 1; //Default
                    if (Object.prototype.hasOwnProperty.call(item, 'count') && item.count && !isNaN(item.count)) {
                        newItem.quantity = item.count;
                    }
          
                    newItem.item_id = item.id;
                    newItem.item_name = item.name;
                    vat = 1 + (parseInt(vat) / 100);
          
                    newItem.price = Math.round(item.price / vat);
                    value = newItem.price * newItem.quantity;
          
                    let gtag = function() {
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push(arguments)
                    }
          
                    gtag('event', 'add_to_cart', {
                        currency: newItem.currency,
                        value: value,
                        items: [newItem],
                    });

                    if (typeof fbq !== 'undefined') {
                        // eslint-disable-next-line
                        fbq('track', 'AddToCart', {
                            content_ids: [newItem.item_id],
                            content_name: newItem.item_name,
                            content_type: 'product',
                            value: value,
                            currency: newItem.currency
                        });
                    }
                }
            }
        } catch(error) {
            Sentry.captureException(error);
        }
    }

    beginCheckout(items) {
    /**
     * Sends an begin checkout event to Google Analytics and Meta Pixel.
     * @param {Array} items - Array of items for the begin_checkout event.
     * @param {Object} item - Parameters for the begin_checkout event.
     * @param {string} item.id - The ID of the item being sent to begin_checkout. Prefix p for products, prefix w for Workout, prefix r for Resource, prefix c for Course and prefix g for TeamSport/GameClass
     * @param {string} item.name - The name of the item being sent to begin_checkout.
     * @param {string} item.currency - The currency of the item being sent to begin_checkout (optional) default = SEK
     * @param {number} item.price - The price of the item being sent to begin_checkout incl. vat (optional) default = 0
     * @param {number} item.vat - The vat of the item being sent to begin_checkout (optional) default = 0
     * @param {number} item.count - The quantity of the item being sent to begin_checkout (optional) default = 1.
    */
    
        try {
            if (getCookie('acceptTrackingCookies') && Array.isArray(items)) {
                let newItems = [];
                let value = 0;
                let currency = 'SEK';

                for (let i = 0; i < items.length; i++) {
                    if (
                        typeof items[i] === 'object' &&
                        Object.prototype.hasOwnProperty.call(items[i], 'id') && items[i].id &&
                        Object.prototype.hasOwnProperty.call(items[i], 'name') && items[i].name
                    ) {
                        let newItem = {};
            
                        newItem.currency = 'SEK'; //Default
                        if (Object.prototype.hasOwnProperty.call(items[i], 'currency') && items[i].currency) {
                            newItem.currency = items[i].currency;
                            currency = items[i].currency;
                        }
                        newItem.price = 0; //Default
                        if (Object.prototype.hasOwnProperty.call(items[i], 'price') && items[i].price && !isNaN(items[i].price)) {
                            newItem.price = items[i].price;
                        }
                        let vat = 0; //Default
                        if (Object.prototype.hasOwnProperty.call(items[i], 'vat') && items[i].vat && !isNaN(items[i].vat)) {
                            vat = items[i].vat;
                        }
                        newItem.quantity = 1; //Default
                        if (Object.prototype.hasOwnProperty.call(items[i], 'count') && items[i].count && !isNaN(items[i].count)) {
                            newItem.quantity = items[i].count;
                        }

                        newItem.item_id = items[i].id;
                        newItem.id = items[i].id;
                        newItem.item_name = items[i].name;
                        vat = 1 + (parseInt(vat) / 100);
                        newItem.price = Math.round(items[i].price / vat);
                        value += newItem.price * newItem.quantity;

                        newItems.push(newItem);
                    }
                }

                if (newItems.length) {
                    if (typeof gtag !== 'undefined') {            
                        let gtag = function() {
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push(arguments)
                        }
                        gtag('event', 'begin_checkout', {
                            currency: 'SEK',
                            value: value,
                            items: newItems
                        });
                    }

                    if (typeof fbq !== 'undefined') {
                        // eslint-disable-next-line
                        fbq('track', 'InitiateCheckout', {
                            contents: newItems,
                            num_items: newItems.length,
                            value: value,
                            currency: currency
                        });
                    }
                }
            }
        } catch(error) {
            Sentry.captureException(error);
        }
    }

    purchase(transaction_id, items) {
    /**
     * Sends an purchase event to Google Analytics and Meta Pixel.
     * @param {string} transaction_id - The unique identifier of a transaction.
     * @param {Array} items - Array of items for the purchase event.
     * @param {Object} item - Parameters for the purchase event.
     * @param {string} item.id - The ID of the item being purchased. Prefix p for products, prefix w for Workout, prefix r for Resource, prefix c for Course and prefix g for TeamSport/GameClass
     * @param {string} item.name - The name of the item being purchased.
     * @param {string} item.currency - The currency of the item being purchased (optional) default = SEK
     * @param {number} item.price - The price of the item being purchased incl. vat (optional) default = 0
     * @param {number} item.vat - The vat of the item being purchased (optional) default = 0
     * @param {number} item.count - The quantity of the item being purchased (optional) default = 1.
    */

        try {
            if (getCookie('acceptTrackingCookies') && Array.isArray(items) && (typeof transaction_id === "string" || !isNaN(transaction_id))) {
                let totalWithoutTax = 0;
                let totalWithTax = 0;
                let newItems = [];
                let currency = 'SEK';

                for (let i = 0; i < items.length; i++) {
                    if (
                        typeof items[i] === 'object' &&
                        Object.prototype.hasOwnProperty.call(items[i], 'id') && items[i].id &&
                        Object.prototype.hasOwnProperty.call(items[i], 'name') && items[i].name
                    ) {
                        let newItem = {};
            
                        newItem.currency = 'SEK'; //Default
                        if (Object.prototype.hasOwnProperty.call(items[i], 'currency') && items[i].currency) {
                            newItem.currency = items[i].currency;
                            currency = items[i].currency;
                        }
                        newItem.price = 0; //Default
                        if (Object.prototype.hasOwnProperty.call(items[i], 'price') && items[i].price && !isNaN(items[i].price)) {
                            newItem.price = items[i].price;
                        }
                        let vat = 0; //Default
                        if (Object.prototype.hasOwnProperty.call(items[i], 'vat') && items[i].vat && !isNaN(items[i].vat)) {
                            vat = items[i].vat;
                        }
                        newItem.quantity = 1; //Default
                        if (Object.prototype.hasOwnProperty.call(items[i], 'count') && items[i].count && !isNaN(items[i].count)) {
                            newItem.quantity = items[i].count;
                        }

                        newItem.item_id = items[i].id;
                        newItem.id = items[i].id;
                        newItem.item_name = items[i].name;
                        vat = 1 + (parseInt(vat) / 100);
            
                        totalWithTax += newItem.price * newItem.quantity;
                        newItem.price = Math.round(newItem.price / vat);
                        totalWithoutTax += newItem.price * newItem.quantity;
                        newItems.push(newItem);
                    }
                }

                if (newItems.length) {
                    if (typeof gtag !== 'undefined') {
                        let gtag = function() {
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push(arguments)
                        }
  
                        gtag('event', 'purchase', {
                            currency: 'SEK',
                            transaction_id: transaction_id,
                            value: totalWithoutTax,
                            tax: totalWithTax - totalWithoutTax,
                            items: newItems
                        });
                    }

                    if (typeof fbq !== 'undefined') {
                        // eslint-disable-next-line
                        fbq('track', 'Purchase', {
                            contents: newItems,
                            num_items: newItems.length,
                            value: totalWithoutTax,
                            currency: currency
                        });
                    }
                }
            }
        } catch(error) {
            Sentry.captureException(error);
        }
    }

    constructor(Vue) {
        Vue.prototype.$ecommercetracking = this;
        window.$ecommercetracking = this;
    }
}

export default {
    install(Vue) {
        new EcommerceTracking(Vue);
    }
}